import React from "react";
import { FilterModalSelect } from "./FilterModalSelect";
import {
  CatalogItem,
  useItems,
} from "src/utils/CommonDataFetchingUtils/useItems";

interface AssetTypeFilterProps {
  assetType: string;
  setSelectedAssetType: (value: string) => void;
}

interface AssetTypeOption {
  name: string;
  value: string;
}

export const AssetTypeFilter = ({
  assetType,
  setSelectedAssetType,
}: AssetTypeFilterProps) => {
  const { items } = useItems();

  const assetTypeOptions: AssetTypeOption[] = [
    ...new Map(
      items.map((item: CatalogItem) => [
        item.typeName,
        { name: item.typeName ?? "", value: item.typeId ?? "" },
      ])
    ).values(),
  ];

  return (
    <FilterModalSelect
      label="Asset Type"
      value={assetType}
      onChange={setSelectedAssetType}
      placeholderText="Select Asset Type"
      options={assetTypeOptions}
    />
  );
};
